module.exports = __webpack_public_path__ + "img/blockables-instructions-0.1d6f412d.png";